@if (rendering(); as rendering) {
  <sc-placeholder name="generic-form-section-dynamic" [rendering]="rendering" />
}
